export const formatDate = (dateString: string, timeZone?: string) => {
    const data = new Date(dateString);
    if (timeZone === "pt-BR") {
        data.setUTCHours(data.getUTCHours() + 3);
    }
    const options: any = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' };
    return data.toLocaleString('pt-BR', options).replaceAll(',','');
}